import { useEffect } from 'react';
import { getNewLinkParams } from './GetNewLinkParams';

export const SearchNavigationHook = (router, onHistoryChange) => {
  let isNavigating = false;

  useEffect(() => {
    if (isNavigating) return;

    onHistoryChange();
  }, [router.asPath]);

  return (addCustomParams) => {
    const linkParams = getNewLinkParams(router, addCustomParams);

    isNavigating = true;

    router.push(
      linkParams.href,
      linkParams.as,
    )
      .then(() => {
        isNavigating = false;
      });
  };
};
